import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoujjaincab() {



  const cardData = {
    keyword: " Mumbai to Ujjain Cab",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Ujjain cab service, providing safe, comfortable, and affordable long-distance pilgrimage and intercity travel for families, devotees, and group journeys. Ujjain is one of the most sacred cities in India, located in Madhya Pradesh, approximately 650–700 km from Mumbai, and is famous for the Mahakaleshwar Jyotirlinga. Our professional drivers ensure a smooth, punctual, and stress-free journey via well-connected highways with proper rest stops and comfortable travel experience. We offer flexible options including one-way drops, round trips, and customized pilgrimage packages covering nearby temples and cities. Our fleet includes economy sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Ujjain cab service.",

"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga Temple",
    "description": "Mahakaleshwar Jyotirlinga Temple is one of the twelve sacred Jyotirlingas of Lord Shiva and the most important religious attraction in Ujjain. It is known for its unique Bhasma Aarti performed early in the morning, powerful spiritual atmosphere, and deep significance in Hindu mythology. Devotees from across India travel from Mumbai by cab to seek blessings at this sacred temple."
  },
  {
    "title": "Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is a famous temple dedicated to Lord Bhairav, a fierce form of Lord Shiva. It is unique for its ritual where devotees offer liquor as prasad. The temple holds strong spiritual importance and is widely visited by pilgrims in Ujjain."
  },
  {
    "title": "Ram Ghat",
    "description": "Ram Ghat is the most prominent ghat on the banks of the Shipra River, known for its evening aarti and religious ceremonies. It is also a major site during the Kumbh Mela, attracting thousands of devotees for holy dips and spiritual rituals."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "Harsiddhi Temple is one of the Shakti Peethas dedicated to Goddess Harsiddhi. It is known for its two large दीप स्तंभ (lamp towers) and strong spiritual aura, making it a must-visit temple in Ujjain."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram is believed to be the place where Lord Krishna, Balram, and Sudama received their education. It holds historical and mythological importance and offers a peaceful environment for spiritual learning and reflection."
  },
  {
    "title": "Mangalnath Temple",
    "description": "Mangalnath Temple is considered the birthplace of planet Mars according to Hindu astrology. It is an important site for performing Mangal dosh remedies and attracts devotees seeking astrological relief."
  },
  {
    "title": "ISKCON Temple Ujjain",
    "description": "ISKCON Temple in Ujjain is a beautiful and peaceful spiritual center dedicated to Lord Krishna. It offers devotional chanting, spiritual discourses, and a calm environment for visitors."
  },
  {
    "title": "Vedh Shala (Jantar Mantar)",
    "description": "Vedh Shala is an ancient astronomical observatory built by Maharaja Jai Singh. It showcases historical instruments used for studying celestial movements, making it a unique attraction for science and history enthusiasts."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "This temple houses a large and beautifully decorated idol of Lord Ganesha. It is located near Mahakaleshwar Temple and is often visited by devotees during their pilgrimage."
  },
  {
    "title": "Shipra River",
    "description": "The Shipra River is considered sacred and plays a central role in Ujjain’s religious life. Pilgrims take holy dips here, especially during festivals and Kumbh Mela, believing it purifies the soul."
  }
],






services: [
  {
    name: "Mumbai to Ujjain Cab",
    description: "Mumbai to Ujjain cab service offers a comfortable and spiritual journey to the holy city of Ujjain, home to Mahakaleshwar Jyotirlinga. Ideal for devotees, families, and long-distance travelers, this service ensures smooth highway travel. Professional drivers and well-maintained vehicles enhance safety. It guarantees a peaceful and hassle-free yatra experience."
  },
  {
    name: "Mumbai to Ujjain Taxi",
    description: "Mumbai to Ujjain taxi provides private and convenient intercity travel with door-to-door pickup. This service is ideal for pilgrimage and long-distance journeys. Comfortable vehicles ensure a pleasant ride. It guarantees a smooth and reliable journey."
  },
  {
    name: "Mumbai to Ujjain Cab Service",
    description: "Mumbai to Ujjain cab service offers professional travel solutions with multiple vehicle options. This service is suitable for religious tours, family trips, and business travel. Clean vehicles and trained drivers ensure comfort. It ensures a safe and pleasant journey."
  },
  {
    name: "Mumbai to Ujjain Taxi Service",
    description: "Mumbai to Ujjain taxi service ensures dependable transportation with comfortable vehicles and experienced chauffeurs. This service is ideal for long-distance travel. Flexible booking options enhance convenience. It guarantees a smooth journey."
  },
  {
    name: "Cab from Mumbai to Ujjain",
    description: "Cab from Mumbai to Ujjain offers a convenient way to travel between cities with complete comfort. This service is ideal for devotees preferring road travel. Professional drivers ensure safe journeys. It ensures a relaxed experience."
  },
  {
    name: "Taxi from Mumbai to Ujjain",
    description: "Taxi from Mumbai to Ujjain provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with experienced drivers. Comfortable seating enhances the experience. It guarantees a dependable ride."
  },
  {
    name: "Mumbai to Ujjain Cab Booking",
    description: "Mumbai to Ujjain cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Ujjain Taxi Booking Online",
    description: "Mumbai to Ujjain taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Ujjain Cab Price",
    description: "Mumbai to Ujjain cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Ujjain Taxi Fare",
    description: "Mumbai to Ujjain taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ujjain One Way Cab",
    description: "Mumbai to Ujjain one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Ujjain Round Trip Taxi",
    description: "Mumbai to Ujjain round trip taxi provides complete travel solutions including return journeys. This service is ideal for pilgrimage trips and extended stays. Flexible schedules enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Ujjain Innova Cab",
    description: "Mumbai to Ujjain Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Ujjain Ertiga Cab",
    description: "Mumbai to Ujjain Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Ujjain Sedan Cab",
    description: "Mumbai to Ujjain sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Ujjain SUV Taxi",
    description: "Mumbai to Ujjain SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra luggage space. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  },
  {
    name: "Cheap Mumbai to Ujjain Cab",
    description: "Cheap Mumbai to Ujjain cab offers budget-friendly travel options without compromising comfort and safety. This service is ideal for cost-conscious travelers. Transparent pricing ensures no hidden charges. It ensures economical travel."
  },
  {
    name: "Best Mumbai to Ujjain Taxi Service",
    description: "Best Mumbai to Ujjain taxi service ensures top-quality vehicles, professional drivers, and excellent customer support. This service focuses on comfort, safety, and punctuality. It guarantees a reliable and premium journey."
  }
],

tableData: [
  ["Mumbai to Ujjain Cab", "Mumbai to Ujjain Taxi"],
  ["Mumbai to Ujjain Cab Service", "Mumbai to Ujjain Taxi Service"],
  ["Cab from Mumbai to Ujjain", "Taxi from Mumbai to Ujjain"],
  ["Mumbai to Ujjain Cab Booking", "Mumbai to Ujjain Taxi Booking Online"],
  ["Mumbai to Ujjain Cab Price", "Mumbai to Ujjain Taxi Fare"],
  ["Mumbai to Ujjain One Way Cab", "Mumbai to Ujjain Round Trip Taxi"],
  ["Mumbai to Ujjain Innova Cab", "Mumbai to Ujjain Ertiga Cab"],
  ["Mumbai to Ujjain Sedan Cab", "Mumbai to Ujjain SUV Taxi"],
  ["Cheap Mumbai to Ujjain Cab", "Best Mumbai to Ujjain Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ujjain Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Ujjain cab service, ideal for Jyotirlinga darshan and long-distance family travel."
  },
  {
    WhyChooseheading: "Experienced Interstate Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate routes, ensuring safe driving, smooth navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Perfect for Mahakaleshwar Jyotirlinga Darshan",
    WhyChoosedescription: "Plan your Ujjain Mahakaleshwar darshan with ease using our reliable cab services designed for pilgrims and families."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Ujjain trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Ujjain cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Religious Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by devotees for Mumbai to Ujjain cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ujjain cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Ujjain for one-way and round trips." },
  { question: "What is the distance between Mumbai and Ujjain?", answer: "The distance is approximately 650 to 700 km and takes around 12 to 14 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ujjain cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for Jyotirlinga darshan?", answer: "Yes, our service is ideal for Mahakaleshwar Jyotirlinga pilgrimage trips." },
  { question: "Do you provide multi-day temple tours?", answer: "Yes, we provide customized multi-day darshan packages including nearby temples." },
  { question: "Do you provide interstate permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended for long-distance travel." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Verma",
    feedback: "The Mumbai to Ujjain cab journey with Royal Route Cabs was very smooth and well-managed. The long-distance travel felt safe and comfortable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Sharma",
    feedback: "Excellent experience traveling from Mumbai to Ujjain. The cab was clean, the driver was polite, and the entire pilgrimage trip felt peaceful and hassle-free.",
    rating: 5
  }
];








  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ujjain Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ujjain-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ujjain cab service with Royal Route Cabs for safe, reliable, and comfortable pilgrimage travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 outstation taxi service to Mahakaleshwar Jyotirlinga Ujjain.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "10999", // approx starting fare (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ujjain-cab"
  }
};






  return (
    <div>
<Helmet>
  <title>Mumbai to Ujjain Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ujjain cab with Royal Route Cabs. Safe and comfortable Mahakaleshwar Jyotirlinga pilgrimage taxi service with sedan, SUV, Innova & Ertiga cars. 24x7 reliable travel."
  />

  <meta
    name="keywords"
    content="mumbai to ujjain cab, mumbai to ujjain taxi, mumbai to ujjain cab service, mumbai to ujjain taxi service, cab from mumbai to ujjain, taxi from mumbai to ujjain, mumbai to ujjain cab booking, mumbai to ujjain taxi booking online, mumbai to ujjain cab price, mumbai to ujjain taxi fare, mumbai to ujjain one way cab, mumbai to ujjain round trip taxi, mumbai to ujjain innova cab, mumbai to ujjain ertiga cab, mumbai to ujjain sedan cab, mumbai to ujjain suv taxi, cheap mumbai to ujjain cab, best mumbai to ujjain taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/64.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoujjaincab;